export const EmbeddedSourceCourseNameOptions = {
  INLINE: 'INLINE',
  BELOW: 'BELOW',
} as const;

export type EmbeddedSourceCourseNameOptionsType =
  (typeof EmbeddedSourceCourseNameOptions)[keyof typeof EmbeddedSourceCourseNameOptions];
